import { h, Component } from "preact";

import { gettext as _ } from "../../utils/i18n";
import lazy_component from "../../utils/lazy_component";

const CollectionModalContainer = lazy_component(() => import("./CollectionModalContainer"));

interface Props {
    id: number;
}

interface State {
    is_modal_open: boolean;
}

/*
 * Add quote to collection or create new collection. Component is responsible for:
 *  - handling list of collection
 *  - AJAX calls
 *  - switching between screen with list of collection and screen with form for creating new collection
 */
export default class CollectionButton extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            is_modal_open: false,
        };
    }

    handle_modal_open(e) {
        // only authenticated users can use collections
        if (!window.USER_IS_AUTHENTICATED) {
            import("../LoginModal/LoginModal").then((LoginModalModule) => {
                LoginModalModule.default.open({
                    heading: _("Login for creating collections"),
                });
            });
            return null;
        }

        this.setState({
            is_modal_open: true,
        });

        e.preventDefault();
    }

    handle_modal_close(e) {
        this.setState({
            is_modal_open: false,
        });

        e.preventDefault();
    }

    render(props: Props, state: State) {
        const aria_label = _("Add to collection");

        return (
            <button class="muted ml-auto" onClick={(e) => this.handle_modal_open(e)} aria-label={aria_label}>
                <svg class="icon mr-1">
                    <use xlinkHref="#bookmark" />
                </svg>
                {state.is_modal_open && (
                    <CollectionModalContainer
                        id={props.id}
                        is_open={state.is_modal_open}
                        onClose={(e) => this.handle_modal_close(e)}
                    ></CollectionModalContainer>
                )}
            </button>
        );
    }
}
